
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.225 24.226"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Komponente 30 – 2"}},[_c('g',{attrs:{"fill":"none","stroke":"#266288","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","transform":"translate(1.311 1.311)","data-name":"Gruppe 2068"}},[_c('circle',{attrs:{"data-name":"Ellipse 29","cx":"7.706","cy":"7.706","transform":"rotate(-23.025 14.798 3.014)","r":"7.706"}}),_c('path',{attrs:{"data-name":"Linie 19","d":"M15.67 15.67l5.829 5.83"}})])])])
          )
        }
      }
    